module.exports = __webpack_public_path__ + "static/media/modal-backer.e8c25b68.png";